import { useDragLayer, type XYCoord } from "react-dnd";
import type { MediaObject } from "src/components/DropZoneInputV2/types.ts";
import { PreviewRowForDragLayer } from "src/components/DropZoneInputV2/components/PreviewRow/PreviewRowForDragLayer.tsx";
import * as React from "react";
import * as styles from "./DragLayer.style.ts";

export const DragLayer = ({
  draggedItemId,
  disablePreviewPicture,
  width,
}: {
  draggedItemId: string | null;
  disablePreviewPicture?: boolean;
  width: number;
}) => {
  const { isDragging, initialOffset, currentOffset, item } = useDragLayer(
    (monitor) => ({
      item: monitor.getItem<MediaObject>(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }),
  );

  if (!draggedItemId) {
    return null;
  }

  if (!isDragging) {
    return;
  }

  if (!initialOffset || !currentOffset) {
    return null;
  }

  function getItemStyles(initialOffset: XYCoord, currentOffset: XYCoord) {
    const { y } = currentOffset;

    const transform = `translate(${initialOffset.x}px, ${y}px)`;
    return {
      transform,
      width: width,
      WebkitTransform: transform,
    };
  }

  return (
    <div css={styles.container}>
      <div style={getItemStyles(initialOffset, currentOffset)}>
        <PreviewRowForDragLayer
          disablePreviewPicture={disablePreviewPicture}
          object={item}
        />
      </div>
    </div>
  );
};
